import { Typography } from 'antd';
import React from 'react';
import { isMobile } from 'react-device-detect';

const { Title } = Typography;

export default function HomeLargeText({ children, extraStyles }) {
  return (
    <Title
      style={{
        maxWidth: !isMobile && '60vw',
        marginTop: 0,
        color: '#181818',
        fontWeight: 700,
        ...extraStyles,
      }}
    >
      {children}
    </Title>
  );
}
